import type { ReactNode } from 'react';

import type { Session } from './api';
import { Sidebar } from './components/Sidebar';
import { activeRouteId } from './routes';

export interface ShellProps {
  readonly session: Session;
  readonly onSignOut: () => void;
  readonly navigate: (hash: string) => void;
  readonly route: { page: string };
}

export function Shell({
  session,
  onSignOut,
  navigate,
  route,
  children,
}: ShellProps & { title?: string; children: ReactNode }) {
  const currentRouteId = activeRouteId(route.page);

  return (
    <div className="flex h-screen overflow-hidden">
      <Sidebar
        session={session}
        currentRouteId={currentRouteId}
        navigate={navigate}
        onSignOut={onSignOut}
      />
      <div className="flex flex-1 flex-col overflow-hidden">
        <main className="flex-1 overflow-auto">
          <div className="mx-auto max-w-[110rem] px-6 py-6">{children}</div>
        </main>
      </div>
    </div>
  );
}
